import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getItems } from "../../services/services";

// Fetch Items
export const fetchItems = createAsyncThunk(
  "items/fetchItems",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getItems(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);

const itemSlice = createSlice({
  name: "items",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload?.response?.products || [];
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default itemSlice.reducer;
